import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field, FieldArray, useFormikContext } from 'formik';
import { connect } from 'react-redux';
import axios from 'axios';
import { getDistributorsOptions } from 'redux/distributors/selector';
import { getUserInstallersOptions } from 'redux/userInstallers/selector';
import { getDinocSheetPreviewSrc } from 'preview/sheetImageSrc';
import { requests as distributorsRequest } from 'redux/distributors/reducer';
import { requests as userInstallersRequest } from 'redux/userInstallers/reducer';
import get from 'lodash/get';
import { substrateTypeOPTs, mainNeedDinoc } from 'enums/formOtps';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import PorletHeader, { PorletHeaderTitle } from 'components/porletHeader';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from 'components/form/input';
import DatePicker from 'components/datePicker';
import Autocomplete from 'components/form/autocomplete';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import FilmCatalogPreview from 'components/filmCatalogPreview';
import './previewer.scss';
const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

const newSheet = {
  film: null,
  filmData: null,
  meters: null,
  need: null,
  substrate: null,
  family: null,
  distributor: null,
  run: null,
};

const newInstaller = {
  id: null,
  name: '',
};

export const initialValues = {
  /* application: {
     need: '',
     substrate: '',
   },*/
  installDate: null,
  installers: [{ ...newInstaller }],
  dinocSheets: [],
  family: {},
};

const filter = createFilterOptions();

const filterOptions = (options, params) => {
  const filtered = filter(options, params);

  if (params.inputValue !== '') {
    filtered.push({
      value: {
        id: -1,
        name: params.inputValue,
      },
      label: (
        <>
          <FormattedMessage id="Agregar A:" /> "{params.inputValue}"
        </>
      ),
      useValue: false,
    });
  }

  return filtered;
};
function clearCustom(state, value, index) {
  let newValue = '';
  if (value == false) {
    state.dinocSheets[index].custom = newValue;
  }
}
const autoCompleteProps = {
  clearOnBlur: true,
  freeSolo: true,
  filterOptions,
  getOptionLabel: (option) =>
    option.useValue ? option.value.name : option.label || '',
  renderOption: (option) => option.label,
  parseNewValue: (value) => ({
    value,
    label: value.name,
  }),
};
function normalizeDinocFilmsPayload(data, family) {
  const list = Array.isArray(data) ? data : data?.data;

  return list;
}

/**
 * @param {string} family
 * @returns {Promise<Array<{ label: string, value: string, family: string }>>}
 */
async function fetchDinocProductsByFamily(family) {
  try {
    const response = await axios.get(`${API_URL}/films/arqfinishes`, {
      params: { family },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
      },
    });
    const raw = normalizeDinocFilmsPayload(response.data, family);
    const items = Array.isArray(raw) ? raw : [];
    return items
      .map((row) => ({
        ...row,
        label: row.label ?? row.name,
      }))
      .sort((a, b) =>
        String(a.label ?? '').localeCompare(String(b.label ?? ''), undefined, {
          sensitivity: 'base',
        }),
      );
  } catch (err) {
    console.error('fetchDinocProductsByFamily', err);
    return [];
  }
}

function normalizeFamiliesPayload(data) {
  const list = Array.isArray(data) ? data : data?.data;
  return Array.isArray(list) ? list : [];
}

/**
 * @param {string} program
 * @returns {Promise<Array<{ label: string, value: string|number, type?: * }>>}
 */
async function fetchFamiliesByProgram(program, type) {
  const url = `${API_URL}/families/${program}?type=${type}`;
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
      },
    });
    const items = normalizeFamiliesPayload(response.data);
    return items.map((value) => ({
      label: value.name,
      value: value.name, // TODO: this must change to id?
      type: value.type,
    }));
  } catch (err) {
    console.error('fetchFamiliesByProgram', err);
    return [];
  }
}

function filmOptionsForRow(family, loadedProducts) {
  if (!family) {
    return [];
  }
  if (family === 'Custom') {
    return [{ value: 'Custom', label: 'Custom' }];
  }
  if (loadedProducts == null) {
    return [];
  }
  return loadedProducts?.map((item) => ({
    label: item.name,
    value: item.name,
  }));
}

const dinocApplicationSheetsMapStateToProps = (state) => ({
  distributorsOptions: getDistributorsOptions(state),
});

const dinocApplicationSheetsMapDispatchToProps = (dispatch) => ({
  fetchDistributors: () => dispatch(distributorsRequest.fetch()),
});

const DinocApplicationSheetRow = ({
  index,
  values,
  familiesOptions,
  filteredOptions,
  onRemove,
  showRemoveButton,
}) => {
  const { setFieldValue } = useFormikContext();
  const family = values.dinocSheets[index]?.family;
  const prevFamilyRef = useRef(family);
  const [familyProducts, setFamilyProducts] = useState(undefined);

  useEffect(() => {
    const prev = prevFamilyRef.current;
    if (prev != null && family != null && prev !== family) {
      setFieldValue(`dinocSheets[${index}].film`, null);
      setFieldValue(`dinocSheets[${index}].filmData`, null);
      setFieldValue(`dinocSheets[${index}].custom`, '');
    }
    prevFamilyRef.current = family;
  }, [family, index, setFieldValue]);

  useEffect(() => {
    let cancelled = false;

    if (!family) {
      setFamilyProducts(undefined);
      return undefined;
    }
    if (family === 'Custom') {
      setFamilyProducts(undefined);
      return undefined;
    }

    setFamilyProducts(null);
    fetchDinocProductsByFamily(family).then((items) => {
      if (!cancelled) {
        setFamilyProducts(items);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [family]);

  const filmDisabled =
    !family || (family !== 'Custom' && familyProducts == null);

  return (
    <div className="row">
      <div className="col-12">
        <PorletHeader>
          <PorletHeaderTitle variant="h6">
            <FormattedMessage id="Aplicación" />
          </PorletHeaderTitle>
        </PorletHeader>
      </div>

      <div className="col-sm-12 col-lg-6">
        <div className="col-12">
          <Field
            name={`dinocSheets[${index}].need`}
            component={Autocomplete}
            label="Principal necesidad: *"
            variant="outlined"
            options={mainNeedDinoc}
          />
        </div>
      </div>

      <div className="col-sm-12 col-lg-6">
        <div className="col-12">
          <Field
            name={`dinocSheets[${index}].substrate`}
            component={Autocomplete}
            label="Sustrato: *"
            variant="outlined"
            options={substrateTypeOPTs}
          />
        </div>
      </div>

      <div className="kt-space-20" />
      <div className="col-sm-12 col-lg-6">
        <div className="row">
          <div className="col-12">
            <Field
              name={`dinocSheets[${index}].family`}
              component={Autocomplete}
              label="Familia *"
              helperText="Por favor seleccione una familia de películas DI-NOC™ "
              variant="outlined"
              options={[
                ...familiesOptions,
                { value: 'Custom', label: 'Custom' },
              ]}
            />
          </div>
        </div>
        <div className="Row">
          <div className="col-12">
            <Field
              name={`dinocSheets[${index}].film`}
              component={Autocomplete}
              label="Producto *"
              helperText="Por favor seleccione una película DI-NOC™ "
              variant="outlined"
              disabled={filmDisabled}
              options={filmOptionsForRow(family, familyProducts)}
              handleChange={(opt) => {
                const v = get(opt, 'value');
                if (v == null || v === '' || v === 'Custom') {
                  setFieldValue(`dinocSheets[${index}].filmData`, null);
                  return;
                }
                if (typeof v === 'object') {
                  setFieldValue(`dinocSheets[${index}].filmData`, null);
                  return;
                }
                const row = Array.isArray(familyProducts)
                  ? familyProducts.find((p) => {
                      const name = p.name ?? p.label;
                      return String(name) === String(v);
                    })
                  : null;
                setFieldValue(
                  `dinocSheets[${index}].filmData`,
                  row ? { ...row } : null,
                );
              }}
              onBlur={clearCustom(
                values,
                values.dinocSheets[index].film == 'Custom' &&
                  values.dinocSheets[index].family == 'Custom',
                index,
              )}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Field
              name={`dinocSheets[${index}].distributor`}
              component={Autocomplete}
              label="Distribuidor"
              helperText="Por favor selecione el distribuidor"
              variant="outlined"
              options={filteredOptions}
              placeholder="Seleccionar"
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Field
              name={`dinocSheets[${index}].meters`}
              component={TextField}
              type="text"
              label="M2 necesarios *"
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Field
              name={`dinocSheets[${index}].run`}
              component={TextField}
              type="text"
              label="Número de RUN:*"
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-lg-6">
        <FilmCatalogPreview
          src={getDinocSheetPreviewSrc({
            family: values.dinocSheets[index].family,
            film: values.dinocSheets[index].film,
            familyProducts,
            filmData: values.dinocSheets[index].filmData,
          })}
          alt=""
          imgClassName="img-previewer w-100"
        >
          <Field
            name={`dinocSheets[${index}].custom`}
            component={TextField}
            type="text"
            label="Custom 3M™ DI-NOC™"
            variant="outlined"
            fullWidth
            disabled={
              values.dinocSheets[index].film == 'Custom' &&
              values.dinocSheets[index].family == 'Custom'
                ? false
                : true
            }
            helperText='Por favor complete sólo si eligió una lámina "CUSTOM"'
          />
        </FilmCatalogPreview>
      </div>

      {showRemoveButton && (
        <>
          <div className="col-12 kt-space-20" />
          <div className="col-12">
            <Button
              size="small"
              variant="outlined"
              fullWidth
              onClick={onRemove}
            >
              <DeleteIcon color="primary" />
              <FormattedMessage id="Eliminar esta lámina" />
            </Button>
            <div className="col-12 kt-space-12" />
          </div>
        </>
      )}
    </div>
  );
};

const DinocApplicationSheetsInner = ({
  country,
  values,
  dinocSheetsError,
  distributorsOptions,
  fetchDistributors,
}) => {
  const [familiesOptions, setFamiliesOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetchFamiliesByProgram('arqfinishes', 'dinoc').then((options) => {
      if (!cancelled) {
        setFamiliesOptions(options);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    fetchDistributors();
  }, [fetchDistributors]);

  const filteredOptions = distributorsOptions;

  // const distributorFiltered = distributorsOptions.filter((distributor) => {
  //   return distributor.users.some((user) => user.dinoc === true);
  // });

  // const filteredOptions = distributorFiltered.filter((option) => {
  //   const isNLorBE = country === 'NL' || country === 'BE';

  //   if (isNLorBE == true) {
  //     return (
  //       !option.label.toLowerCase().includes('3m') &&
  //       !option.label.toLowerCase().includes('test') &&
  //       !option.label.toLowerCase().includes('distributor') &&
  //       !/^[a-z]+distributor/.test(option.label.toLowerCase())
  //     );
  //   } else {
  //     return (
  //       !option.label.toLowerCase().includes('test') &&
  //       !option.label.toLowerCase().includes('distributor') &&
  //       !/^[a-z]+distributor/.test(option.label.toLowerCase())
  //     );
  //   }
  // });

  return (
    <FieldArray name="dinocSheets">
      {({ push, remove }) => (
        <>
          {values.dinocSheets.length < 1 ? push(newSheet) : <></>}
          {values.dinocSheets.map((_, index) => (
            <DinocApplicationSheetRow
              key={index}
              index={index}
              values={values}
              familiesOptions={familiesOptions}
              filteredOptions={filteredOptions}
              onRemove={() => remove(index)}
              showRemoveButton={values.dinocSheets.length > 0}
            />
          ))}
          {values.dinocSheets.length < 6 && (
            <>
              <div className="kt-space-20" />

              <div className="row">
                <div className="col-12">
                  <Button
                    size="small"
                    variant="outlined"
                    fullWidth
                    onClick={() => push(newSheet)}
                  >
                    <FormattedMessage id="Agregar nueva lámina" />
                  </Button>
                </div>
              </div>
            </>
          )}
          {typeof dinocSheetsError === 'string' && (
            <div className="row">
              <div className="col-sm-12">
                <FormHelperText error={Boolean(dinocSheetsError)}>
                  {dinocSheetsError}
                </FormHelperText>
              </div>
            </div>
          )}
          <div className="kt-space-20" />
        </>
      )}
    </FieldArray>
  );
};

const DinocApplicationSheets = connect(
  dinocApplicationSheetsMapStateToProps,
  dinocApplicationSheetsMapDispatchToProps,
)(DinocApplicationSheetsInner);

export const Step3 = ({
  country,
  values,
  errors: { dinocSheets },
  prevStep,
  fetchUserInstallersRequest,
  userInstallersOptions,
}) => {
  useEffect(() => {
    fetchUserInstallersRequest();
  }, [fetchUserInstallersRequest]);

  return (
    <>
      <div className="kt-space-20" />
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-2" />
        <div className="col-sm-12 col-md-12 col-lg-8">
          <div className="row">
            <div className="col-12">
              <PorletHeader>
                <PorletHeaderTitle variant="h6">
                  <FormattedMessage id="Colocación" />
                </PorletHeaderTitle>
              </PorletHeader>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-lg-6">
              <div className="col-12">
                <FieldArray name="installers">
                  {({ push, remove }) => (
                    <>
                      {values.installers.map((_, index) => (
                        <div className="row" key={index}>
                          <div className="col-12">
                            <Field
                              name={`installers[${index}]`}
                              component={Autocomplete}
                              emptyValue={newInstaller}
                              autoCompleteProps={autoCompleteProps}
                              label="Instalador *"
                              helperText="Por favor seleccione la persona que realizó la colocación"
                              variant="outlined"
                              options={userInstallersOptions}
                              placeholder="Seleccionar"
                              InputLabelProps={{ shrink: true }}
                            />
                          </div>
                          {values.installers.length > 1 && (
                            <>
                              <div className="col-12 kt-space-20" />
                              <div className="col-12">
                                <Button
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                  onClick={() => remove(index)}
                                >
                                  <DeleteIcon color="primary" />
                                  <FormattedMessage id="Eliminar este instalador" />
                                </Button>
                                <div className="col-12 kt-space-12" />
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                      {values.installers.length <= 4 && (
                        <>
                          <div className="kt-space-20" />

                          <div className="row">
                            <div className="col-12">
                              <Button
                                size="small"
                                variant="outlined"
                                fullWidth
                                onClick={() => push(newInstaller)}
                              >
                                <FormattedMessage id="Agregar nuevo instalador" />
                              </Button>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="kt-space-20" />
                    </>
                  )}
                </FieldArray>
              </div>
            </div>
            <div className="col-sm-12 col-lg-6">
              <div className="col-12">
                <Field
                  component={DatePicker}
                  fullWidth
                  name="installDate"
                  label={<FormattedMessage id="Fecha de instalación" />}
                  inputVariant="outlined"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-12 col-lg-2" />
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-2" />
        <div className="col-sm-12 col-md-12 col-lg-8">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="row">
                <div className="col-12">
                  <div className="kt-space-20" />
                  <PorletHeader>
                    <PorletHeaderTitle variant="h6">
                      <FormattedMessage id="3M™ DI-NOC™" />
                    </PorletHeaderTitle>
                  </PorletHeader>
                </div>
              </div>
              <DinocApplicationSheets
                country={country}
                values={values}
                dinocSheetsError={dinocSheets}
              />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-2" />
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-2" />
        <div className="col-sm-12 col-md-12 col-lg-8 submit-bottons">
          <Button variant="contained" type="submit" color="primary">
            <FormattedMessage id="Siguiente" />
          </Button>
          <Button variant="outlined" onClick={prevStep}>
            <FormattedMessage id="Atrás" />
          </Button>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-2" />
      </div>
    </>
  );
};

export const mapStateToProps = (state, { values: { installers } }) => ({
  userInstallersOptions: getUserInstallersOptions(state).filter(
    (item) => !installers.find((installer) => installer.id === item.value.id),
  ),
});
export const mapDispatchToProps = (dispatch) => ({
  fetchUserInstallersRequest: () => dispatch(userInstallersRequest.fetch()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
